import { Box, BoxProps } from '@chakra-ui/react';

export type EventBoundaryProps = BoxProps;

export function EventBoundary({ children, ...boxProps }: EventBoundaryProps) {
   return (
      <Box onClick={e => e.stopPropagation()} {...boxProps}>
         {children}
      </Box>
   );
}
